import {
	AttachmentsPath,
	ConfigPath,
	ContentsPath,
	OverviewPath,
	RewardsPath,
} from "../../educational-offer.paths";

export const TabsOrder = [
	OverviewPath.pathKey,
	ContentsPath.pathKey,
	AttachmentsPath.pathKey,
	ConfigPath.pathKey,
	RewardsPath.pathKey,
] as const;
